<template>
  <div class="ab_position ab_position_name">
    <span v-html="getPlayerHtmlPosition(position)"> </span>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'

export default {
  name: 'HaPosition',
  mixins: [format_mix],
  props: {
    position: String,
  },
  methods: {
    getPlayerHtmlPosition(position) {
      if (position === 'UTG+1') {
        return `<span style="letter-spacing:-1px">UTG1</span>`
      }
      if (position === 'UTG+2') {
        return `<span style="letter-spacing:-1px">UTG2</span>`
      }
      return position
    },
  },
}
</script>

<style lang="scss" scoped>
.ab {
  &_position {
    position: relative;
    z-index: 2;
    font-size: var(--ha-position-size);
    font-weight: var(--ha-position-weight);
    min-width: var(--ha-position-width);
    width: var(--ha-position-width);
    flex-shrink: 0;
    height: 1.5rem;
    &_name {
      color: var(--ha-position-color);
      display: flex;
      align-items: center;
    }
  }
}
</style>
